import { makeStyles } from "@material-ui/core/styles";

export const OffersAndPromStyles = makeStyles((theme) => ({
  promsGrid: {
    [theme.breakpoints.down("sm")]: {
      padding: "0em",
    },
  }
}));
